import { createSlice } from "@reduxjs/toolkit";
import { GlobalSearchResultDTO } from "../../models/Contact.model";
import { globalSearch } from "../thunks/globalSearchThunks";

interface GlobalSearchState {
  results: GlobalSearchResultDTO[] | null;
  loading: boolean;
  error: string | null;
  searchText: string;
  searchType: string;
  hasSearched: boolean;
}

const initialState: GlobalSearchState = {
  results: null,
  loading: false,
  error: null,
  searchText: "",
  searchType: "ALL",
  hasSearched: false,
};

const globalSearchSlice = createSlice({
  name: "globalSearch",
  initialState,
  reducers: {
    clearSearch: (state) => {
      state.results = null;
      state.loading = false;
      state.error = null;
      state.searchText = "";
      state.searchType = "ALL";
      state.hasSearched = false;
    },
    setSearchType: (state, action) => {
      state.searchType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(globalSearch.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.searchText = action.meta.arg.searchText;
        state.searchType = action.meta.arg.searchType;
      })
      .addCase(globalSearch.fulfilled, (state, action) => {
        state.loading = false;
        state.results = action.payload.result;
        state.hasSearched = true;
      })
      .addCase(globalSearch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Global search failed";
        state.results = null;
        state.hasSearched = true;
      });
  },
});

export const { clearSearch, setSearchType } = globalSearchSlice.actions;

export default globalSearchSlice.reducer;

// Selectors
export const selectGlobalSearchResults = (state: {
  globalSearch: GlobalSearchState;
}) => state.globalSearch.results;

export const selectGlobalSearchLoading = (state: {
  globalSearch: GlobalSearchState;
}) => state.globalSearch.loading;

export const selectGlobalSearchError = (state: {
  globalSearch: GlobalSearchState;
}) => state.globalSearch.error;

export const selectGlobalSearchText = (state: {
  globalSearch: GlobalSearchState;
}) => state.globalSearch.searchText;

export const selectGlobalSearchType = (state: {
  globalSearch: GlobalSearchState;
}) => state.globalSearch.searchType;

export const selectGlobalSearchHasSearched = (state: {
  globalSearch: GlobalSearchState;
}) => state.globalSearch.hasSearched;
